<template>
    <v-container fluid>
        <v-layout column justify-center>
            <v-form v-model="validForm" id="validForm" ref="formTiposSolicitudesClienteWeb" autocomplete="off" >
                <v-row 
                    v-for="(tipo, index) in configuracion.tiposSolicitudes"
                    :key="'tipoSolicitudes'+index"
                    align="center"
                    dense
                    class="mt-3"
                >
                    <v-col cols="4">
                    <v-text-field
                        v-model="configuracion.tiposSolicitudes[index].nombre"
                        id="tipoSolicitud"
                        :label="localization.tiposSolicitudes.nombre"
                        color="primary"
                        hide-details
                        readonly
                        :disabled="saving || tipo.habilitar === false"
                        @change="updateCambiado(true)"
                    />
                    </v-col>
                    <v-col cols="5">
                    <v-checkbox
                        v-model="tipo.habilitarClienteWeb"
                        id="habilitar"
                        :label="$t('sectionConfiguracion.tiposSolicitudes.habilitar', {tipo: configuracion.tiposSolicitudes[index].nombreBase})"
                        color="primary"
                        hide-details
                        :disabled="saving || tipo.habilitar === false"
                        @change="borrarPromociones(tipo.habilitarCliente, tipo.codigoTipoSolicitud); updateCambiado(true)"
                    />
                    </v-col>
                    <v-col cols="5" v-if="tipo.habilitarClienteWeb === true">
                        <div @click="tipo.habilitar === true ? mostrarPopupPromociones(tipo.codigoTipoSolicitud) : ''">
                            <v-autocomplete :no-data-text="$t('sinDatos')"
                                v-model="configuracion.promocionesTipoSolicitudClienteWeb[tipo.codigoTipoSolicitud]" id="promocionesTiposSolicitudClienteWeb"
                                :items="promociones"
                                :label="'Promociones ' + configuracion.tiposSolicitudes[index].nombre"
                                :hint="'Promociones ' + configuracion.tiposSolicitudes[index].nombre"
                                item-value="id"
                                item-text="nombreCompleto"
                                :disabled="saving || tipo.habilitar === false"
                                readonly
                                multiple
                                :rules="[rules.required]"
                                @change="popupPromociones($event)"
                            >
                            </v-autocomplete>
                        </div>
                    </v-col>
                </v-row>
            </v-form>
            <v-fade-transition>
            <custom-dialog
                v-if="mostrarSeleccionarPromociones"
                v-model="mostrarSeleccionarPromociones" id="mostrarSeleccionarPromociones"
                >
                <PopUpSeleccionarPromociones
                    :multiple="true"
                    @selected="popupSeleccionarPromociones($event)"
                    :yaSeleccionado="promocionesSelectedPopUp[itemTipoSolicitud]"
                />
            </custom-dialog>
        </v-fade-transition>
        </v-layout>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import PopUpSeleccionarPromociones from '../incidencias/maestros/PopUpSeleccionarPromociones'
import rulesMixin from '@/components/generic/rules.js'

export default{
    mixins: [rulesMixin],
    components: {
        PopUpSeleccionarPromociones
    },
    props: {
        configuracion: {
            type: Object,
            required: true
        },
        item: {
            type: Object,
            required: true
        },
        saving: {
            type: Boolean,
            default: false
        },
        valid: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            idubapi: JSON.parse(localStorage.idubapi),
            mostrarSeleccionarPromociones: false,
            itemTipoSolicitud: null,
            validForm: true,
            promocionesSelectedPopUp: []
        }
    },
    mounted() {
        this.getPropertiesDevelopment()
    },
    computed: {
        localization () {
            return this.$t('sectionConfiguracion')
        },
        promociones () {
            if (this.$store.state.incidencias.promociones) {
                return this.$store.state.incidencias.promociones.map(x => {
                return {
                    ...x,
                    nombreCompleto: (this.idubapi.motor === 'SQLSERVER') ? x.name + ' - ' + x.code : x.code + ' - ' + x.name
                }
                })
            }
            return []
        },
    },
    methods: {
        ...mapActions({
            getPropertiesDevelopment: 'incidencias/getPropertiesDevelopment'
        }),
        updateCambiado (val) {
            this.$refs.formTiposSolicitudesClienteWeb.validate()
            if ( this.validForm === false ) {
                this.$emit('toggleValidProp', false)
            }
            this.$emit('cambiado', val)
        },
        mostrarPopupPromociones (itemTipoSolicitud) {
            this.itemTipoSolicitud = itemTipoSolicitud
            this.formatearEstructuraPromocionesPopUp()

            if ( this.mostrarSeleccionarPromociones === false ) {
                this.mostrarSeleccionarPromociones = true
            }
            else {
                this.mostrarSeleccionarPromociones = false
            }
            this.updateCambiado(true)
        },
        formatearEstructuraPromocionesPopUp() {
            let promociones = this.promociones
            if ( this.configuracion.promocionesTipoSolicitudClienteWeb[this.itemTipoSolicitud] !== undefined ) {
                this.promocionesSelectedPopUp[this.itemTipoSolicitud] = this.configuracion.promocionesTipoSolicitudClienteWeb[this.itemTipoSolicitud].map ( function (x) {  
                    return promociones.find( (promocion) => promocion.id == x ) 
                })
            }
        },
        popupSeleccionarPromociones (promocionesSelected) {
            this.configuracion.promocionesTipoSolicitudClienteWeb[this.itemTipoSolicitud] = (promocionesSelected != null && promocionesSelected.length > 0 ? promocionesSelected.map( x => x.id) : []) 
        },
        borrarPromociones (habilitado, itemTipoSolicitud) {
            if ( habilitado === false) {
                this.configuracion.promocionesTipoSolicitudClienteWeb[itemTipoSolicitud] = []
            } else {
                this.configuracion.promocionesTipoSolicitudClienteWeb[itemTipoSolicitud] = this.promociones.map( x => x.id )
            }
        },
    },
    watch: {
        saving () {
            this.$refs.formTiposSolicitudesClienteWeb.validate()
            if ( this.validForm === false ) {
                this.$emit('toggleValidProp', false)
            }
            else {
                this.$emit('toggleValidProp', true)
            }

        }
    }
}
</script>